import React from 'react';
import { Input } from 'view/component/Input/Input';
import { MensagemErro } from 'view/component/Formulario/MensagemErro/MensagemErro';
import { SolicitacaoDetalhada } from 'model/solicitacao/SolicitacaoDetalhada';
import { ClassificacaoCascaderStyled} from 'view/component/ClassificacaoCascader/ClassificacaoCascader';
import { Editor } from 'view/component/Editor/Editor';
import { AnexosSolicitacaoSection } from 'view/section/Anexos/AnexosSolicitacaoSection';



interface SolicitacaoFormularioProps {
  solicitacao: SolicitacaoDetalhada;
}

export const SolicitacaoFormulario: React.FC<SolicitacaoFormularioProps> = ({solicitacao}) => {
  return (<>
    <fieldset>
      <legend className="h3 sr-only">Solicitação de serviço</legend>
      
      <label htmlFor="titulo">Título</label>
      <Input name="titulo" id="titulo" type="text" placeholder="Título da solicitação..." />
      <MensagemErro name="titulo" />

      <label htmlFor="classificacao.id">Classificação</label>
      <div>
        <ClassificacaoCascaderStyled name="classificacao.id" placeholder="Classificação..." />
      </div>
      <MensagemErro name="classificacao" />

      <label htmlFor="descricao">Descrição</label>
      <div>
        <Editor name="descricao" id="descricao" required />
      </div>

      <MensagemErro name="descricao" />
    </fieldset>

    <fieldset>
      <AnexosSolicitacaoSection name="extra" solicitacao={solicitacao} />
    </fieldset>
  </>) 
}
